module.exports = __webpack_public_path__ + "static/media/skyll-l.0926ab44.mp3";